import { gql } from '@apollo/client';

export const GET_TEAMS = gql`
  query GetTeams {
    teams(order_by: { id: asc }) {
      id
      champion
      color
      colorSecondary
      name
      seasonBySeason {
        id
        league
        season
        year
      }
      captainPlayer {
        id
        firstName
        lastName
      }
    }
  }
`;
